<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Map Manager</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-5">
        <label for="ddlMaps">Map:</label>
        <select class="form-control" id="ddlMaps" v-model="selected_map_id">
          <option value="0">Select..</option>
          <option v-for="map in maps" :key="map.map_id" v-bind:value="map.map_id">
            {{ map.name }}
          </option>
        </select>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-5">
        <router-link :to="{ name:'AdminMapAdd' }" class="btn btn-success"><i class="fa fa-edit"
                                                                                  aria-hidden="true"></i>
          Add Map
        </router-link>
        <button class="btn btn-outline-danger" @click="deleteMap(selected_map_id)" v-if="selected_map_id !== '0'"><i
          class="fa fa-trash fa-fw" aria-hidden="true"></i>Delete Map</button>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
        <img :src="'/upload/images/' + selected_map_id + '.png'" class="img-fluid" alt="<MapImage>">
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: function () {
    return {
      selected_map_id: '0'
    }
  },
  computed: {
    ...mapGetters({
      maps: 'siteMaps',
      scoped_site_id: 'scopedSiteId'
    })
  },
  created () {
    this.$store.dispatch('getMaps')
  },
  methods: {
    deleteMap (mapId) {
      this.$store.dispatch('deleteMap', mapId)
      this.selected_map_id = '0'
    }
  }
}
</script>
